import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    methods: {
        ...mapMutations({
            setRememberCustomer: 'remembered/SET_CUSTOMER',
            setRememberPayment: 'remembered/SET_PAYMENT',
            setRememberCredit: 'remembered/SET_CREDIT',
            setRememberCategory: 'remembered/SET_CATEGORY',
            setRememberAttribute: 'remembered/SET_ATTRIBUTE',
            setRememberProduct: 'remembered/SET_PRODUCT',
            setRememberBundle: 'remembered/SET_BUNDLE',
            setRememberOrder: 'remembered/SET_ORDER',
            setRememberStockTransfer: 'remembered/SET_STOCKTRANSFER',
            setRememberBatchPicks: 'remembered/SET_BATCHPICKS',
            setLocations: 'locations/SET_LOCATIONS',
            setAbility: 'auth/SET_ABILITIES',
            setEnv: 'env/SET_ENV'
        }),

        ...mapActions({
            signOutAction: 'auth/signOut'
        })
    },

    computed: {
        ...mapGetters({
            env: 'env/getEnv',
            getLocations: 'locations/locations',
            rememberedCustomer: 'remembered/customer',
            rememberedPayment: 'remembered/payment',
            rememberedCredit: 'remembered/credit',
            rememberedCategory: 'remembered/category',
            rememberedAttribute: 'remembered/attribute',
            rememberedProduct: 'remembered/product',
            rememberedBundle: 'remembered/bundle',
            rememberedOrder: 'remembered/order',
            rememberedStockTransfer: 'remembered/stocktransfer',
            rememberedBatchPicks: 'remembered/batchpicks',
            authenticated: 'auth/authenticated',
            user: 'auth/user',
            abilities: 'auth/abilities'
        })
    },
}
